module.exports = __webpack_public_path__ + "static/media/plants1.3640f234.jpg";